export const Role = {
    Administrator: 1,
    User: 2,
}